import "@fae/source/engine/testing/utility/node.js"

import Testlaunch from "@fae/source/engine/testing/utility/Testlaunch.js"

import tests from "@fae/source/data/tests.js"
const results = Testlaunch.do(tests)

if(window.environment != "node") {
    window.fae = window.fae || {}
    window.fae.test = window.fae.test || {}
    window.fae.test.results = results

    window.fae.test.log = function() {
        Testlaunch.report(window.fae.test.results)
    }
} else if(window.environment == "node") {
    if(results != undefined) {
        if(results.badcount <= 0) {
            Testlaunch.report(results, {
                "header": true,
                "footer": true,
                "hierarchy": false,
            })
        } else if(results.badcount > 0) {
            Testlaunch.report(results, {
                "includePassingTests": false,
                "includeSkippedTests": false,
                "hierarchy": false,
                "header": false,
                "footer": true,
            })

            throw "Testing Failed"
        }
    }
}

export default {
    "results": results
}
